import axios from 'axios';
import { API_SERVER } from '../helpers/constants';
export const signin = (body) => axios.post(`${API_SERVER}/login`, body);
export const signup = (body) => axios.post(`${API_SERVER}/registerUser`, body);
